import { IUpdateScript, IFieldSchema, IModelOptions } from "../../interfaces";

export class MongooseUpDownScript implements IUpdateScript {

    addColumn(model: string, key: string, options: IFieldSchema): void {
        
    }
    alterColumn(model: string, key: string, options: IFieldSchema): void {

    }
    renameColumn(model: string, key: string, newKey: string): void {

    }
    removeColumn(model: string, key: string): void {

    }
    addTable(model: string, options: IModelOptions): void {

    }
    removeTable(model: string): void {

    }
    renameTable(model: string, newModel: string): void {

    }
    alterTable(model: string, options: IModelOptions): void {

    }
}